import * as React from 'react';

function SvgEllipsisVertical(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M12 14.309a2.308 2.308 0 100-4.616 2.308 2.308 0 000 4.616zM12 22a2.308 2.308 0 100-4.615A2.308 2.308 0 0012 22zM12 6.615A2.308 2.308 0 1012 2a2.308 2.308 0 000 4.615z" })));
}

export default SvgEllipsisVertical;
